// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__ApplicationOverview__lihRr{display:flex;flex-direction:column;gap:var(--tri-space-200)}`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/ApplicationDetailsTabContent/ApplicationOverview/styles.module.scss"],"names":[],"mappings":"AAAA,qCACE,YAAA,CACA,qBAAA,CACA,wBAAA","sourcesContent":[".ApplicationOverview {\n  display: flex;\n  flex-direction: column;\n  gap: var(--tri-space-200);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ApplicationOverview": `sputnik__ApplicationOverview__lihRr`
};
export default ___CSS_LOADER_EXPORT___;
